import { Row, Col } from '@geberit/gdds';

// components
import { ZipEntry } from 'components/ContentElementsGdds/locator/zip-entry';
import { LocatorContainer } from 'components/ContentElementsGdds/locator/overview-page/showroom-locator.styles';
import { LocatorConsent } from 'components/ContentElementsGdds/locator/consent';
import { SearchContextProvider } from 'components/ContentElementsGdds/locator/search';
import { GoogleMapProvider } from 'components/ContentElementsGdds/locator/overview-page/google-map-provider';
import { StyledWrapper, Wrapper } from './showroom-locator-teaser.styles';
import { SectionClosingLine } from 'components/ContentElementsGdds/Common/section-closing-line';

// utils
import { useUCConsent } from 'features/cookie-consent';
import { useLocatorConfiguration } from 'components/ContentElementsGdds/locator/utils/use-locator-configuration';
import { useIsPreview } from 'utils/hooks/useIsPreview';
import { Log } from 'services/log';
import { useSectionId } from 'utils/hooks/use-section-id';

type ShowroomLocatorTeaserProps = {
  locatorUrl?: string;
  previewId: string;
  title: string;
  subtitle?: string;
  titleInAnchor?: boolean;
  anchor?: string;
  contentIndex?: number;
  border: '' | 'disabled-border';
};

export function ShowroomLocatorTeaser({
  title,
  subtitle,
  titleInAnchor,
  anchor,
  contentIndex,
  border,
  locatorUrl,
}: ShowroomLocatorTeaserProps) {
  const consent = useUCConsent();
  const locatorConsent = useLocatorConfiguration();
  const isPreview = useIsPreview();
  const sectionId = useSectionId(title, anchor, titleInAnchor, contentIndex);

  const showConsent = consent.Comfort === false && locatorConsent !== undefined;
  const showZipEntry = consent.Comfort === true;

  if (!locatorUrl) {
    if (isPreview) {
      return (
        <LocatorContainer isSection id={sectionId}>
          <Row>
            <Col>
              <StyledWrapper>
                <p>locator url is missing in projectsettings!</p>
              </StyledWrapper>
            </Col>
          </Row>
        </LocatorContainer>
      );
    }

    Log.error('locator url is missing in projectsettings!');
    return null;
  }

  return (
    <SearchContextProvider locatorPath={locatorUrl}>
      <Wrapper id={sectionId}>
        {showConsent && <LocatorConsent {...locatorConsent?.consent} />}
        {!showConsent && (
          <GoogleMapProvider>
            <LocatorContainer isSection>
              <Row>
                <Col>
                  {showZipEntry && <ZipEntry isSection headline={title} subHeadline={subtitle} />}
                </Col>
              </Row>
            </LocatorContainer>
          </GoogleMapProvider>
        )}
        {!border && <SectionClosingLine />}
      </Wrapper>
    </SearchContextProvider>
  );
}
